import { useLazyQuery } from "@apollo/client/react";
import { MenuItem } from '@mui/material';
import { ButtonOptionGroup } from '../../../components/buttonOptionGroup/ButtonOptionGroup';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { PopoverModal } from '../../../components/popoverModal/PopoverModal';
import { TextInput } from '../../../components/textInput/TextInput';

import ClearIcon from '@mui/icons-material/Clear';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SearchIcon from '@mui/icons-material/Search';
import { FormControl, Grid, InputAdornment, InputLabel, Select, Stack, TextField } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import toast from 'react-hot-toast';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { useForm } from '../../../components/hooks/useForm';
import { GET_DELEGACIONES, GET_PROVEEDORES } from '../../../data/graphQL/queries/Utils/queries';
import { useDebounce } from '../../../hooks/useDebounce';
import { getDateNow } from '../../../utils/convert';
import './tabDatosContables.scss';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { CustomDialog } from '../../../components/customDialog/CustomDialog';

export default function TabDatosContables({ listaDatosContables, setListaDatosContables, permisoGrabar }) {

  const [
  rows,
  setRows,
  proveedoresOriginal,
  setProveedoresOriginal,
  filterStatus,
  setFilterStatus] =
  useGetProveedores();

  const [openDlgConfirmacion, setOpenDlgConfirmacion] = useState(false);
  const [textoDlgConfirmacion, setTextoDlgConfirmacion] = useState('');
  const [loadingDlgConfirmacion, setloadingDlgConfirmacion] = useState(false);

  const txtFiltro = useRef(null);

  const [item, setItem] = useState('');

  const [anioActual, setAnioActual] = useState('');
  const [mesActual, setMesActual] = useState('');

  const [editarItemGrilla, setEditarItemGrilla] = useState(false);

  const [openDlgProveedores, setOpenDlgProveedores] = useState(false);

  const [openDlgDatosContables, setOpenDlgDatosContables] = useState(false);


  const txtFiltroProveedor = useRef(null);
  const [loadingBuscarProveedores, setLoadingBuscarProveedores] = useState(false);

  const [listaDatosContablesLocal, setListaDatosContablesLocal] = useState([]);

  const [selectedTipoCostoFilter, setSelectedTipoCostoFilter] = useState(0);


  const [formValues, formHandle, reset, setFormValues] = useForm({
    Mes: '',
    Anio: '',
    TipoCosto: false,
    IdDelegacion: 0,
    Costo1: '',
    Costo2: '',
    CostoInterno: '',
    Iva: '',
    CodigoProveedor: '',
    DescripcionProveedor: ''
  });


  const [delegaciones, setDelegaciones] = useState([]);
  const [disableDelegacion, setDisableDelegacion] = useState(true);

  useEffect(() => {
    getDelegaciones({ variables: { idRegion: 0 } });

    const anioActual = getDateNow().getFullYear();
    const mesActual = getDateNow().getMonth() + 1;

    setFormValues({
      ...formValues,
      Mes: mesActual,
      Anio: anioActual
    });

    setAnioActual(anioActual);
    setMesActual(mesActual);

    setListaDatosContablesLocal(listaDatosContables);
  }, []);

  // Consultas de combos
  const [getDelegaciones, { data: dataDeleg }] = useLazyQuery(GET_DELEGACIONES, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataDeleg) return;
    if (dataDeleg.delegaciones.success) {
      setDelegaciones(dataDeleg.delegaciones.valorEsperado);
    };
  }, [dataDeleg]);  

  const getDescripcionDelegacion = (id) => {
    if (delegaciones.length > 0) {
      const row = delegaciones.find((x) => x.idDelegacion === id);
      return row ? row.descripcion : '';
    }
    return '';
  };

  const getDescripcionTipoCosto = (id) => {
    return id > 1 ? 'Local' : 'Global';
  };

  const handleAceptarDlgConfirmacion = () => {
    let listado = listaDatosContables.filter((x) => x.mes != mesActual && x.anio == anioActual || x.anio != anioActual);
    setListaDatosContables((current) => [...listado]);
  };

  const handleTipoCostoClick = (event) => {
    let value = event;
    setSelectedTipoCostoFilter(value);

    if (listaDatosContables.length > 0) {
      let item;
      if (value === 0)
      item = listaDatosContables.filter((x) => x.idDelegacion > 1 && x.mes == mesActual && x.anio == anioActual);else

      item = listaDatosContables.filter((x) => x.idDelegacion == 1 && x.mes == mesActual && x.anio == anioActual);

      if (item.length > 0) {
        const msj = formValues.TipoCosto ? 'Local' : 'Global';
        setTextoDlgConfirmacion("Ya existe un período del tipo " + msj + " en el período seleccionado. Si desea continuar, se eliminara...");
        setOpenDlgConfirmacion(true);
      }
    }

    setDisableDelegacion(value === 0);

    setFormValues({
      ...formValues,
      TipoCosto: value
    });


  };

  const handleCancelarDlgConfirmacion = () => {
    setloadingDlgConfirmacion(false);
    setOpenDlgConfirmacion(false);

    setFormValues({
      ...formValues,
      TipoCosto: !formValues.TipoCosto
    });

    setDisableDelegacion(formValues.TipoCosto);
    setSelectedTipoCostoFilter(formValues.TipoCosto <= 1 ? 0 : 1);
  };

  const handleChangeTipoCosto = (event) => {

    if (listaDatosContables.length > 0) {
      let item;
      if (!event.target.checked)
      item = listaDatosContables.filter((x) => x.idDelegacion > 1 && x.mes == mesActual && x.anio == anioActual);else

      item = listaDatosContables.filter((x) => x.idDelegacion == 1 && x.mes == mesActual && x.anio == anioActual);

      if (item.length > 0) {
        const msj = formValues.TipoCosto ? 'Local' : 'Global';
        setTextoDlgConfirmacion("Ya existe un período del tipo " + msj + " en el período seleccionado. Si desea continuar, se eliminara...");
        setOpenDlgConfirmacion(true);
      }
    }

    setDisableDelegacion(!event.target.checked);

    setFormValues({
      ...formValues,
      TipoCosto: event.target.checked
    });
  };

  const handleAdd = () => {

    if (isValidItem(false)) {
      const array = listaDatosContables;

      const id = -1 * listaDatosContables.length - 1;
      let objeto = {
        idCostoInsumo: id,
        mes: formValues.Mes,
        anio: formValues.Anio,
        idDelegacion: formValues.IdDelegacion > 0 ? formValues.IdDelegacion : 1,
        costo1: parseFloat(formValues.Costo1),
        costo2: parseFloat(formValues.Costo2),
        costoInterno: parseFloat(formValues.CostoInterno),
        iva: parseFloat(formValues.Iva),
        cod_Proveedor: formValues.CodigoProveedor,
        proveedor: formValues.DescripcionProveedor
      };

      array.push(objeto);
      setListaDatosContables(array);
      //setListaDatosContables(current => [...current, objeto]);

      limpiarCampos();

      setOpenDlgDatosContables(false);
    }

  };

  const handleEditItem = () => {

    if (isValidItem(true)) {
      const array = listaDatosContables;

      let objeto = {
        idCostoInsumo: item.idCostoInsumo,
        mes: formValues.Mes,
        anio: formValues.Anio,
        idDelegacion: formValues.IdDelegacion > 0 ? formValues.IdDelegacion : 1,
        costo1: parseFloat(formValues.Costo1),
        costo2: parseFloat(formValues.Costo2),
        costoInterno: parseFloat(formValues.CostoInterno),
        iva: parseFloat(formValues.Iva),
        cod_Proveedor: formValues.CodigoProveedor,
        proveedor: formValues.DescripcionProveedor
      };

      const index = array.findIndex((x) => x.idCostoInsumo === item.idCostoInsumo);
      array[index] = objeto;

      setListaDatosContables(array);

      setEditarItemGrilla(false);
      limpiarCampos();
      setDisableDelegacion(!formValues.TipoCosto);

      setOpenDlgDatosContables(false);
    }
  };

  const handleEditItemCancel = () => {
    setEditarItemGrilla(false);
    limpiarCampos();
    setDisableDelegacion(!formValues.TipoCosto);
  };

  const handleDelete = (row) => {
    let listado = listaDatosContables.filter((x) => x.idCostoInsumo != row.idCostoInsumo);

    setListaDatosContables((current) => [...listado]);
  };

  const handleEdit = (row) => {
    let item = listaDatosContables.find((x) => x.idCostoInsumo === row.idCostoInsumo);

    setItem(item);

    const descripcionProveedor = item.proveedor + ' (' + item.cod_Proveedor + ')';
    setFormValues({
      ...formValues,
      Mes: item.mes,
      Anio: item.anio,
      TipoCosto: item.idDelegacion > 1,
      IdDelegacion: item.idDelegacion > 1 ? item.idDelegacion : 0,
      Costo1: item.costo1,
      Costo2: item.costo2,
      CostoInterno: item.costoInterno,
      Iva: item.iva,
      CodigoProveedor: item.cod_Proveedor,
      DescripcionProveedor: descripcionProveedor
    });

    setEditarItemGrilla(true);

    setSelectedTipoCostoFilter(item.idDelegacion > 1 ? 1 : 0);

    setDisableDelegacion(true);

    setOpenDlgDatosContables(true);
  };

  const handleSearch = () => {
    // si se ingresó texto a buscar (al menos 3 caracteres) --> filtro, sino retorno todos los registros
    // originales consultados
    if (txtFiltro.current.value != "") {
      if (txtFiltro.current.value.length >= 3) {
        setListaDatosContablesLocal(listaDatosContables.filter((listaDatosContables) => {
          const anioBuscar = listaDatosContables.anio.toString();
          const mesBuscar = listaDatosContables.mes.toString();
          const delegacionBuscar = listaDatosContables.idDelegacion.toString();

          const inputBuscar = txtFiltro.current.value.toUpperCase();

          // si se puede parsear a numero, busca por anio y fecha
          if (parseInt(inputBuscar)) {
            const inputAnio = inputBuscar.toString().substring(0, 4);
            const inputMes = inputBuscar.toString().substring(5);

            return (
              anioBuscar.includes(inputAnio) && mesBuscar.includes(inputMes));

          } else
          {
            const delegacionesBuscar = delegaciones.filter((x) => x.descripcion.includes(inputBuscar)).map((item) => item.idDelegacion);

            return (
              delegacionesBuscar.length > 0 && delegacionBuscar.includes(delegacionesBuscar));

          }

        }
        ));
      }
    } else {
      setListaDatosContablesLocal(listaDatosContables);
    }
  };

  const handleClean = () => {
    txtFiltro.current.value = "";
    handleSearch();
    txtFiltro.current.focus();
  };

  const isValidItem = (edit) => {
    if (listaDatosContables.length > 0) {
      if (!formValues.TipoCosto) {
        if (!edit && listaDatosContables.find((x) => x.idDelegacion == 1 && x.mes == mesActual && x.anio == anioActual)) {
          toast.error('No puede existir más de un item del tipo costo Global para un mismo período.');
          return false;
        } else
        if (listaDatosContables.find((x) => x.idDelegacion > 1 && x.mes == mesActual && x.anio == anioActual)) {
          toast.error('No puede existir distintos tipos de costos para un mismo período.');
          return false;
        }
      } else
      {
        if (!edit && listaDatosContables.find((x) => x.idDelegacion == formValues.IdDelegacion && x.mes == mesActual && x.anio == anioActual)) {
          toast.error('La delegación ya fue cargada.');
          return false;
        }
      }
    }

    if (formValues.Mes.length <= 0) {
      toast.error('Debe ingresar el campo Mes.');
      return false;
    }
    if (formValues.Anio.length <= 0) {
      toast.error('Debe ingresar el campo Año.');
      return false;
    }
    if (formValues.TipoCosto) {
      if (formValues.IdDelegacion <= 0) {
        toast.error('Debe ingresar el campo Delegacion.');
        return false;
      }
    }
    if (formValues.Costo1.length <= 0) {
      toast.error('Debe ingresar el campo Costo 1.');
      return false;
    }
    if (formValues.CostoInterno.length <= 0) {
      toast.error('Debe ingresar el campo Costo Interno.');
      return false;
    }
    if (formValues.Costo2.length <= 0) {
      toast.error('Debe ingresar el campo Costo 2.');
      return false;
    }
    if (formValues.Iva.length <= 0) {
      toast.error('Debe ingresar el campo IVA.');
      return false;
    }
    if (formValues.CodigoProveedor.length <= 0) {
      toast.error('Debe ingresar el campo Codigo Proveedor.');
      return false;
    }


    return true;
  };

  const limpiarCampos = () => {
    setFormValues({
      ...formValues,
      IdDelegacion: 0,
      Costo1: '',
      Costo2: '',
      CostoInterno: '',
      Iva: '',
      CodigoProveedor: '',
      DescripcionProveedor: ''
    });
  };

  // handles de Dialog Proveedores
  const handleSearchProveedores = () => {
    setOpenDlgProveedores(true);
  };

  const handleSearchProveedor = () => {
    // si se ingresó texto a buscar (al menos 3 caracteres) --> filtro, sino retorno todos los registros
    // originales consultados
    if (txtFiltroProveedor.current.value != "") {
      if (txtFiltroProveedor.current.value.length >= 3) {
        setRows(proveedoresOriginal.filter((proveedoresOriginal) => {
          const nombreBuscar = proveedoresOriginal.nombre.toLowerCase();
          const codigoBuscar = proveedoresOriginal.cod_Proveedor.toLowerCase();
          const cuitBuscar = proveedoresOriginal.cUIT.toLowerCase();

          const inputBuscar = txtFiltroProveedor.current.value;
          return (
            nombreBuscar.includes(inputBuscar) ||
            codigoBuscar.includes(inputBuscar) ||
            cuitBuscar.includes(inputBuscar));

        }
        ));
      }
    } else {
      setRows(proveedoresOriginal);
    }
  };

  const handleCleanProveedor = () => {
    txtFiltroProveedor.current.value = "";
    handleSearchProveedor();
    txtFiltroProveedor.current.focus();
  };

  const handleRowClickProveedor = (params) => {
    setLoadingBuscarProveedores(false);
    setOpenDlgProveedores(false);

    const descripcionProveedor = params.row.nombre + ' (' + params.row.cod_Proveedor + ')';

    setFormValues({
      ...formValues,
      CodigoProveedor: params.row.cod_Proveedor,
      DescripcionProveedor: descripcionProveedor
    });
  };

  const handleCloseDlgProveedor = () => {
    setOpenDlgProveedores(false);
    setLoadingBuscarProveedores(false);
  };

  // generate columns grillas
  const initialColumns = [
  {
    headerName: '',
    field: 'action',
    flex: 0.02,
    renderCell: (params) => {
      const row = params.row;
      return (
        <>
                        {row.anio == anioActual && row.mes == mesActual &&
          <PopoverModal>

                                <div className='assistance-table-popover-content'>
                                    <div onClick={() => handleEdit(params.row)} aria-hidden='true'
              className='item-option clickable-option'>
                
                                        <EditIcon className='edit-icon' />
                                        <span className='toggle-action'>Editar</span>
                                    </div>
                                    <div onClick={() => handleDelete(params.row)} aria-hidden='true'
              className='item-option'>
                
                                        <DeleteIcon className='edit-icon' />
                                        <span className='toggle-action'>Eliminar</span>
                                    </div>
                                </div>
                            </PopoverModal>
          }
                    </>);

    }
  },
  {
    field: 'tipoCosto',
    headerAlign: 'left',
    headerName: 'Tipo Costo',
    valueGetter: (_, row) => {
      return getDescripcionTipoCosto(row.idDelegacion);
    }
  },
  {
    field: 'periodo',
    headerName: 'Periodo',
    valueGetter: (_, row) => {
      return row.anio + '/' + row.mes;
    }
  },
  {
    field: 'idDelegacion',
    flex: 0.5,
    headerName: 'Delegacion',
    valueGetter: (idDelegacion) => {
      return getDescripcionDelegacion(idDelegacion);
    }
  },
  {
    field: 'costoInterno',
    headerName: 'Costo Interno'
  },
  {
    field: 'costo1',
    headerName: 'Costo 1'
  },
  {
    field: 'costo2',
    headerName: 'Costo 2'
  },
  {
    field: 'iva',
    headerName: 'IVA',
    valueGetter: (iva) => iva + '%'
  }];


  const columns = generateColumnsDefaultConfiguration(initialColumns);

  const initialColumnsProveedor = [
  {
    field: 'cod_Proveedor',
    headerName: 'Codigo'
  },
  {
    field: 'nombre',
    headerName: 'Nombre'
  },
  {
    field: 'cUIT',
    headerName: 'CUIT'
  }];


  const columnsProveedor = generateColumnsDefaultConfiguration(initialColumnsProveedor);

  const handleCrear = () => {
    setOpenDlgDatosContables(true);
    setEditarItemGrilla(false);
    //setSelectedTipoCostoFilter(0);


    //setEditarItemGrilla(true);
    //setSelectedTipoCostoFilter((item.idDelegacion > 1) ? 1 : 0)
    //setDisableDelegacion(true);

    // setOpenDlgDatosContables(true);
  };

  const handleClose = () => {
    setOpenDlgDatosContables(false);
    limpiarCampos();
  };



  return (
    <>
            <CustomDialog
        open={openDlgDatosContables}
        maxWidth='md'
        fullWidth={true}
        title={!editarItemGrilla ? 'Crear Dato Contable' : 'Editar Dato Contable'}
        onCancel={handleClose}
        cancelText='Cerrar'
        onAccept={!editarItemGrilla ? handleAdd : handleEditItem}
        acceptText={!editarItemGrilla ? 'Crear' : 'Aplicar'}>
        
                <div className='insumos-tab-datosContables'>
                    <Grid
            container
            direction="row"
            justifyContent="space-between"
            spacing={2}>
            
 <Grid lg="auto" size={{ xs: 4, sm: 4, md: 3 }}>
                            <div className='insumos-tab-datosContables-linea-control'>
                                <TextField
                  sx={{ background: 'white', width: '100%' }}
                  label="Mes"
                  name="Mes"
                  onChange={formHandle}
                  size="small"
                  type="number"
                  value={formValues.Mes}
                  variant="outlined"
                  InputProps={{ inputProps: { min: 1, max: 12 } }}
                  disabled={true} />
                
                            </div>
                        </Grid>
 <Grid lg="auto" size={{ xs: 4, sm: 4, md: 3 }}>
                            <div className='insumos-tab-datosContables-linea-control'>
                                <TextField
                  sx={{ background: 'white', width: '100%' }}
                  label="Año"
                  name="Año"
                  onChange={formHandle}
                  size="small"
                  type="number"
                  value={formValues.Anio}
                  variant="outlined"
                  InputProps={{ inputProps: { min: 1, max: 12 } }}
                  disabled={true} />
                
                            </div>
                        </Grid>
 <Grid lg="auto" size={{ xs: 4, sm: 4, md: 3 }}>
                            <div className='insumos-tab-datosContables-linea-control'>
                                <span className='span-row'>Tipo&nbsp;Costo</span>
                                <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
                                    <ButtonOptionGroup
                    options={['Global', 'Local']}
                    onOptionClick={!editarItemGrilla ? handleTipoCostoClick : () => {}}
                    selectedOption={selectedTipoCostoFilter}
                    disabled={editarItemGrilla} />
                  
                                </FormControl>
                            </div>
                        </Grid>
 <Grid size={{ xs: 4, sm: 4, md: 3, lg: 5.5 }}>
                            <div className='insumos-tab-datosContables-linea-control'>
                                <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size="small">
                                    <InputLabel id="select-delegacion">Delegacion</InputLabel>
                                    <Select
                    labelId="select-delegacion"
                    id="Delegacion"
                    value={formValues.IdDelegacion}
                    label="Delegacion"
                    onChange={(e) => {
                      setFormValues(
                        {
                          ...formValues,
                          IdDelegacion: e.target.value
                        });
                    }
                    }
                    disabled={disableDelegacion}>
                    
                                        <MenuItem value={0} selected> Seleccionar delegación </MenuItem>
                                        {delegaciones && delegaciones.map((delegacion) => {
                      return <MenuItem value={delegacion.idDelegacion}> {delegacion.descripcion} </MenuItem>;
                    })}
                                    </Select>
                                </FormControl>
                            </div>
                        </Grid>
                    </Grid>

                    <Grid
            container
            justifyContent={'space-between'}
            columns={{
              xs: 2,
              md: 8
            }}>
            
 <Grid sx={{ boxSizing: 'border-box', width: '100%', paddingTop: '2%' }} size={{ xs: 1.8 }}>
                            <Stack direction="row" spacing={1} alignItems="center">
                                <TextField
                  className="input"
                  label="Costo Interno"
                  name="CostoInterno"
                  onChange={formHandle}
                  size="small"
                  type="number"
                  value={formValues.CostoInterno}
                  variant="outlined" />
                
                            </Stack>
                        </Grid>
 <Grid sx={{ boxSizing: 'border-box', width: '100%', paddingTop: '2%' }} size={{ xs: 1.8 }}>
                            <Stack direction="row" spacing={1} alignItems="center">
                                <TextField
                  className="input"
                  label="Costo 1"
                  name="Costo1"
                  onChange={formHandle}
                  size="small"
                  type="number"
                  value={formValues.Costo1}
                  variant="outlined" />
                
                            </Stack>
                        </Grid>
 <Grid sx={{ boxSizing: 'border-box', width: '100%', paddingTop: '2%' }} size={{ xs: 1.8 }}>
                            <Stack direction="row" spacing={1} alignItems="center">
                                <TextField
                  className="input"
                  label="Costo 2"
                  name="Costo2"
                  onChange={formHandle}
                  size="small"
                  type="number"
                  value={formValues.Costo2}
                  variant="outlined" />
                
                            </Stack>
                        </Grid>
 <Grid sx={{ boxSizing: 'border-box', width: '100%', paddingTop: '2%' }} size={{ xs: 1.8 }}>
                            <Stack direction="row" spacing={1} alignItems="center">
                                <TextField
                  className="input"
                  label="IVA"
                  name="Iva"
                  onChange={(e) => {
                    const valor = e.target.value;
                    if (valor <= 100) {
                      setFormValues(
                        {
                          ...formValues,
                          Iva: valor
                        });
                    }
                  }
                  }
                  size="small"
                  type="number"
                  value={formValues.Iva}
                  variant="outlined" />
                
                            </Stack>
                        </Grid>
                    </Grid>
                    <Grid
            container
            justifyContent={'space-between'}
            columns={{
              xs: 2,
              md: 8
            }}>
            
 <Grid sx={{ boxSizing: 'border-box', width: '100%', paddingTop: '2%' }} size={{ xs: 8 }}>
                            <Stack direction="row" spacing={1} alignItems="center">
                                <TextInput
                  label='Buscar proveedor'
                  searchIcon
                  placeholder='Buscar proveedor'
                  onClick={handleSearchProveedores}
                  value={formValues.DescripcionProveedor} />
                
                            </Stack>
                        </Grid>
                    </Grid>
                </div>
            </CustomDialog>

            <Grid
        container
        justifyContent={'space-between'}
        columns={{
          xs: 2,
          md: 8
        }}>
        
 <Grid size="grow">
                    <TextField
            fullWidth
            label="Filtrar"
            name="txtFiltro"
            size="small"
            type="text"
            variant="outlined"
            inputRef={txtFiltro}
            onKeyUp={handleSearch}
            sx={{ backgroundColor: 'white' }}
            InputProps={{
              endAdornment:
              <InputAdornment position="end">
                                    <SearchIcon
                  onClick={handleSearch}
                  sx={{ cursor: 'pointer' }} />
                
                                    <ClearIcon
                  onClick={handleClean}
                  sx={{ cursor: 'pointer' }} />
                
                                </InputAdornment>

            }} />
          
                </Grid>
 <Grid size="grow">
                    {
          permisoGrabar &&
          <CustomButton
            variant='contained'
            onClick={handleCrear}
            size='small'
            className='custom-buttom-primary-color-2'>
            
                            Crear Nuevo
                        </CustomButton>
          }

                </Grid>
            </Grid>

 <Grid sx={{ boxSizing: 'border-box', width: '100%', paddingTop: '2%', paddingBottom: '1%' }} size={{ xs: 12 }}>
                <DataGridGenerico
          columns={columns}
          fileNameExport='DatosContables'
          rows={listaDatosContablesLocal}
          toolbar={false}
          totalCount={listaDatosContablesLocal.length} />
        
            </Grid>

            <CustomDialog
        maxWidth="md"
        open={openDlgConfirmacion}
        title={'Confirmación'}
        onCancel={handleCancelarDlgConfirmacion}
        onAccept={handleAceptarDlgConfirmacion}>
        
                <strong>{textoDlgConfirmacion}</strong>
            </CustomDialog>

            <CustomDialog
        maxWidth="lg"
        fullWidth={true}
        open={openDlgProveedores}
        title={'Selecciona Proveedor'}
        onCancel={handleCloseDlgProveedor}
        cancelText='Cerrar'>
        
                <div style={{ display: 'flex', width: '100%' }}>
                    <FormControl sx={{ backgroundColor: 'white', width: 300 }} size="small">
                        <div style={{ display: 'flex', width: '100%' }}>
                            <TextField
                label="Filtrar"
                name="txtFiltroProveedor"
                size="small"
                type="text"
                variant="outlined"
                inputRef={txtFiltroProveedor}
                onKeyUp={handleSearchProveedor}
                sx={{ backgroundColor: 'white' }}
                InputProps={{
                  endAdornment:
                  <InputAdornment position="end">
                                            <SearchIcon
                      onClick={handleSearchProveedor}
                      sx={{ cursor: 'pointer' }} />
                    
                                            <ClearIcon
                      onClick={handleCleanProveedor}
                      sx={{ cursor: 'pointer' }} />
                    
                                        </InputAdornment>

                }} />
              
                        </div>
                    </FormControl>
                </div>
                <br />
                <DataGridGenerico
          columns={columnsProveedor}
          rows={rows}
          toolbar={false}
          onRowClick={handleRowClickProveedor}
          totalCount={rows.length} />
        
            </CustomDialog>
        </>);

}

const useGetProveedores = () => {
  const [proveedores, setProveedores] = useState([]);
  const [proveedoresOriginal, setProveedoresOriginal] = useState([]);

  const [filterStatus, setFilterStatus] = useState('');
  const debouncedFilterValue = useDebounce(filterStatus, 1000);

  const [getProveedores, { data: dataProveedores, loading: proveedoresLoading }] = useLazyQuery(GET_PROVEEDORES, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataProveedores) return;
    if (dataProveedores.proveedores.success) {
      setProveedores(dataProveedores.proveedores.valorEsperado);
      setProveedoresOriginal(dataProveedores.proveedores.valorEsperado);
    };
  }, [dataProveedores]);

  useEffect(() => {
    if (!proveedoresLoading) {
      getProveedores();
    }
  }, [debouncedFilterValue]);
  return [
  proveedores || [],
  setProveedores,
  proveedoresOriginal,
  setProveedoresOriginal,
  filterStatus,
  setFilterStatus];

};